export function getHeaderTheme(appearance) {
    switch (appearance) {
        case 'Blue':
            return BLUE_HEADER_THEME;
        case 'Pink':
            return PINK_HEADER_THEME;
        case 'Purple':
            return PURPLE_HEADER_THEME;
        case 'Gray':
            return GRAY_HEADER_THEME;
        case 'Lavender':
            return LAVENDER_HEADER_THEME;
        case 'Dark Gray':
            return DARK_GRAY_HEADER_THEME;
        default:
            return BLUE_HEADER_THEME;
    }
}
const BLUE_HEADER_THEME = {
    backgroundColorFixed: 'trelloblue',
    linkColor: 'N0',
    linkColorHover: 'N0',
    login: {
        prominence: 'Reduced',
        spacing: 'Right'
    },
    signup: {
        appearance: 'Creative',
        prominence: 'Reduced'
    }
};
const PINK_HEADER_THEME = {
    backgroundColorFixed: 'M300',
    linkColor: 'N0',
    linkColorHover: 'N0',
    login: {
        prominence: 'Reduced',
        spacing: 'Right'
    },
    signup: {
        appearance: 'Creative',
        prominence: 'Reduced'
    }
};
const PURPLE_HEADER_THEME = {
    backgroundColorFixed: 'P400',
    linkColor: 'N0',
    linkColorHover: 'N0',
    login: {
        prominence: 'Reduced',
        spacing: 'Right'
    },
    signup: {
        appearance: 'Creative',
        prominence: 'Reduced'
    }
};
const GRAY_HEADER_THEME = {
    backgroundColor: 'N20',
    backgroundColorFixed: 'N20',
    linkColor: 'N100',
    linkColorHover: 'N300',
    login: {
        appearance: 'Muted',
        prominence: 'Reduced',
        spacing: 'Right'
    },
    signup: {
        appearance: 'Creative',
        prominence: 'Reduced'
    }
};
const LAVENDER_HEADER_THEME = {
    backgroundColorFixed: 'P50',
    linkColor: 'trelloblue',
    linkColorHover: 'trelloblue',
    login: {
        prominence: 'Reduced',
        spacing: 'Right'
    },
    signup: {
        appearance: 'Creative',
        prominence: 'Reduced'
    }
};
const DARK_GRAY_HEADER_THEME = {
    backgroundColorFixed: 'N400',
    linkColor: 'N0',
    linkColorHover: 'N0',
    login: {
        prominence: 'Reduced',
        spacing: 'Right'
    },
    signup: {
        appearance: 'Light',
        prominence: 'Reduced'
    }
};
//# sourceMappingURL=themes.js.map